import * as Views from "./views";


const Module = {
    name: "calendars",
    defaultRoutePath: "/calendars/carcalendar",
    menuItemScope: "fleet",
    menuItemName: "carcalendarrecord",

    routes: [
        {
            path: "/calendars/carcalendar",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        // {
        //     path: "create",
        //     Component: Views.Create,
        // },
    ]
}



export default Module;
